import { Injectable } from '@angular/core';
import { Codification } from './../model/Codification';

@Injectable({
  providedIn: 'root'
})
export class CodificationService {

  private codifications: Codification[] = [
    new Codification(),
    new Codification("color", "assets/images/color.png", 7)
  ]
  constructor() { }

  public getRandom() {
    return this.codifications[Math.floor(Math.random() * (this.codifications.length))];
  }

  public getCodification(type: string): Promise<Codification> {
    return Promise.resolve(this.codifications.filter(c => c.type == type)[0]);

  }
}
